import { type EquationField } from '@/components/data-table/display/fields/Field';
import { type FieldRenderProps } from '@/components/data-table/display/fields/FieldRender';

export function EquationRender({ value }: FieldRenderProps<EquationField>) {
  return (
    <p
      className="size-full truncate p-2 text-right"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: value }}
    />
  );
}
